import { render, staticRenderFns } from "./PruebaTesting.vue?vue&type=template&id=78d80f80&"
import script from "./PruebaTesting.vue?vue&type=script&lang=js&"
export * from "./PruebaTesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports